<template>
<div class="wrap">
  <p class="tip">请选择您感兴趣的领域</p>
  <ul class="pros">
    <li v-for="item in professions" :class={active:item.isslect} @click="handleClick(item.index)">{{item.name}}</li>
  </ul>
  <button id="submit_btn" @click="submit"><span>提交</span></button>
  <p class="tab" @click="goback"><span>暂不选择</span></p>
</div>
</template>

<script>
    export default {
      data() {
        return {
          professions:[
            {id:1,name:'骨科',isslect:false},
            {id:2,name:'内分泌',isslect:false},
            {id:2,name:'儿科',isslect:false},
            {id:2,name:'检验',isslect:false},
            {id:2,name:'皮肤科',isslect:false},
            {id:2,name:'康复',isslect:false},
            {id:2,name:'神经内科',isslect:false},
            {id:2,name:'心内',isslect:false},
            {id:2,name:'脑血管',isslect:false},
            {id:2,name:'全科',isslect:false},
            {id:2,name:'妇产科',isslect:false},
            {id:2,name:'胸外科',isslect:false},
            {id:2,name:'消化内科',isslect:false}
          ],
        }
      },
      methods:{
        handleCLick(index){
          professions[index].isslect=!professions[index].isslect
        },
        submit(){
          window.history.go(-3);
        },
        goback(){
          window.history.go(-3);
        }
      }

    }
</script>

<style scoped lang="scss">
  .wrap{
    padding-top: 1rem;
    .tip{
      width: 90%;
      margin: 1rem auto 0px;
      font-weight:bolder;
      font-size: 0.5rem;
    }
    .pros{
      width: 90%;
      font-size: .28rem;
      margin: 2.01rem auto 0px;

      li{
        display: inline-block;
        padding:0.1rem;
        border-radius: .1rem;
        border:1px solid #1B94F5 ;
        margin:.2rem ;
      }
      .active{
        background:#1B94F5 ;
      }
    }
    .tab{
      text-align: center;
      padding-top: 0.2rem;
      font-size: 0.24rem;
      span{
        color:#128FFF;
      }
    }
  }
  #submit_btn{
    width:6rem;
    height:0.9rem;
    background:linear-gradient(0deg,rgba(2,130,255,1) 0%,rgba(32,174,255,1) 100%);
    border-radius:10px;
    font-size:0.36rem;
    font-weight:500;
    color:rgba(255,255,255,1);
    margin: 3.01rem auto 0px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/userlable.vue